import {Injectable} from "@angular/core";
import {CDSNode} from "./capd.model";

@Injectable()
export class OrgDataService {

    currentOrg: CDSNode;

    setCurrentOrg(org: CDSNode) {
        this.currentOrg = org;
    }

    getCurrentOrg() {
        return this.currentOrg;
    }

}
